import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { ApiError, api, fetchApi } from '@/lib/api';
import { urlSanitize } from '@/lib/utils';
import ItemNotFound from './$name/-components/item-not-found';

export const Route = createFileRoute('/item/$uin/')({
  notFoundComponent: ItemNotFound,
  loader: async ({ params }) => {
    const { uin } = params;
    const uinNumber = Number(uin);

    if (Number.isNaN(uinNumber)) {
      throw notFound();
    }

    try {
      const result = await fetchApi(api.api.items({ uin }).name.get());
      // Items freshly discovered by the tracker can land with an empty `name`
      // (KSP omits the title for outlet/מציאון listings until a later cycle).
      // urlSanitize('') returns '', which would serialise the redirect target
      // back to `/item/${uin}/` — the same URL we're handling — producing an
      // infinite loop that saturates the per-IP rate limit and surfaces as
      // 429s on the item page. Fall back to a stable per-uin placeholder slug
      // so the URL actually changes; once the real name arrives, the
      // canonical-URL enforcement in `$name.tsx` will redirect to the proper
      // slug on the next visit.
      const sanitizedName = urlSanitize(result.name) || `item-${uin}`;

      throw redirect({
        to: '/item/$uin/$name',
        params: {
          uin,
          name: sanitizedName,
        },
        throw: true,
      });
    } catch (error) {
      if (error instanceof ApiError && error.status === 404) {
        throw notFound();
      }
      throw error;
    }
  },
});
